import { useState } from "react";
import { AiFillSetting, AiOutlineUp } from "react-icons/ai";
import {
  Camera,
  CAMOFF,
  MICOFF,
  Microphone,
  RecordOFF,
  RecordON,
  RecordReady,
  Rotate,
  ScreenOff,
  ScreenOn,
} from "../../../../assets/icons";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import useAppAccessor from "../../../../hooks/useappAccessor";
import {
  saveInteractionAPI,
  startRecordAPI,
  stopRecordAPI,
} from "../../../../services/record.service";
import {
  startRecordingData,
  stopRecordingData,
} from "../../../record-video/record-video.action";
import {
  checkRecord,
  hideSettingPage,
  OffcheckRecord,
  setCamBeforeScreenShare,
  setRotateDegree,
  showSettingPage,
  startRecord,
  turnOffCamera,
  turnOffMic,
  turnOffRecord,
  turnOffScreenSharing,
  turnOnCamera,
  turnOnMic,
  turnOnScreenSharing,
} from "./controls.actions";

const StreamControls = ({ isGoliveStatus, userCheck, alertCameraState, alertSomeoneShared,setMicSelectorVisible, setCamSelectorVisible, checkIfAnyoneSharing }:any) => {
  const dispatch = useAppDispatch();
  const { getControls, getLiveMainData, getUserData, getInteractions } = useAppAccessor();
  const { presenterNum, streamState } = getLiveMainData();
  const { isShowSettings, isCameraOn, isMicOn, isRecord, isScreenSharing, cameraOnBeforeScreenShare, usePortrait, rotateDegree, coPresenterInfo } = getControls();
  const { interactionData } = getInteractions();

  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const { user } = getUserData();
  const { publicUserData } = user;
  const { configurationData } = getLiveMainData();

  const isHost = () => {
    return window.location.href.indexOf('/stream') > -1
  }

  const someoneElseSharing =
    Array.isArray(coPresenterInfo) &&
    coPresenterInfo.some((item: any) => item.isScreenSharing);
  
  const toggleRecording = () => {
    try {
      if (isRecord) {
        stopRecordAPI()
          .then((res) => {
            dispatch(stopRecordingData(res));
          })
          .catch((error) => {
            console.error("Error stopRecordAPI:", error);
          });

        dispatch(turnOffRecord());
      } else if (userCheck?.publicUserData?.company_name) {
        setLoading(true);
        setCountdown(3);
        const countdownInterval = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        setTimeout(() => {
          clearInterval(countdownInterval);
          setCountdown(0);
          setLoading(false);
          var screenSharingUid = coPresenterInfo.find((item: any) => item.isScreenSharing)?.uid;
          dispatch(startRecord());

          startRecordAPI(isScreenSharing ? {
            streamConfigs : {
              height: '720',
              width: '1280',
              fps: 30,
              bitrate: 3000,
            },
            screenSharingUid: screenSharingUid || null,
            requestedQuality: 'medium'
          } : {
            streamConfigs : usePortrait ?
            {
              height: '640',
              width: '360',
              fps: 30
            } :
             {
              height: '720',
              width: '960',
              fps: 30
            },
            requestedQuality: 'medium'
          }, presenterNum)
            .then((res) => {
              dispatch(startRecordingData(res));

              // Use current/existing interactions if available, otherwise use empty array
              const recordData = interactionData && interactionData.length > 0 
                ? interactionData 
                : [];

              saveInteractionAPI(
                configurationData?.stream_id,
                recordData
              );
            })
            .catch((error) => {
              console.error("Error startRecordAPI:", error);
            });
        }, 3000);
      } else {
        dispatch(checkRecord());
        setTimeout(() => {
            dispatch(OffcheckRecord());
        },3500)
        return;
      }
    } catch (error) {
      console.error("Error toggleRecording:", error);
    }
  };

  return (
    <>
      <div
        className="flex space-x-4 h-[40px] bg-[#202121] pl-5 pr-5 items-center w-max "
        id="controlsStream"
      >
        {  !(/Mobi|Android/i.test(navigator.userAgent)) &&
         <div
          className={`text-white relative inline-block ${someoneElseSharing && !isScreenSharing ? "cursor-not-allowed opacity-70" : ""}`}
          onClick={() => {
            if (someoneElseSharing && !isScreenSharing) {
              alertSomeoneShared();
              return;
            }
            if (streamState == 'started') {
              if (isScreenSharing) {
                if (cameraOnBeforeScreenShare) {
                  dispatch(turnOnCamera());
                } else {
                  dispatch(turnOffScreenSharing());
                }
                dispatch(turnOffScreenSharing());
              } else {
                if (checkIfAnyoneSharing()) {
                  alertSomeoneShared();
                } else {
                  dispatch(turnOffCamera());
                  dispatch(turnOnScreenSharing());
                }

              }
            }
          }}
          title={someoneElseSharing && !isScreenSharing ? "Screen Sharing not available when someone else is sharing" : undefined}
        >
          <img
            src={isScreenSharing ? ScreenOn : ScreenOff}
            id={isScreenSharing ? 'ScreenOn' : 'ScreenOff'}
            alt="screenShare"
            height={22}
            width={22}
            style={{ height: "22px" }}
            className="cursor-pointer"
          ></img>
          {someoneElseSharing && !isScreenSharing && (
            <span
              className="absolute inset-0 flex items-center justify-center pointer-events-none"
              aria-hidden
            >
              <span
                className="block w-[120%] h-0.5 rounded bg-red-500"
                style={{ transform: "rotate(-45deg)", boxShadow: "0 0 1px #000" }}
              />
            </span>
          )}
        </div>
        }

        <div
          className="text-white"
          onClick={() => {
            isMicOn ? dispatch(turnOffMic()) : dispatch(turnOnMic());
          }}
        >
          <img
            src={isMicOn ? Microphone : MICOFF}
            alt="camera"
            height={22}
            width={22}
            style={{ height: "22px" }}
            className="cursor-pointer"
          ></img>
        </div>
        {isMicOn && <div
          className="text-white"
          onClick={() => {
            setMicSelectorVisible(true);
          }}
        >
          <AiOutlineUp
            size={16}
            color={"#ffffff"}
            className="cursor-pointer"
          />
        </div>}
        <div
          className="text-white"
          onClick={() => {
            if (!isScreenSharing) {
              if (isCameraOn) {
                dispatch(turnOffCamera());
                dispatch(setCamBeforeScreenShare(false));
              } else {
                dispatch(turnOnCamera());
                dispatch(setCamBeforeScreenShare(true));
              }
            } else {
              alertCameraState();
            }
          }}
        >
          <img
            src={isCameraOn ? Camera : CAMOFF}
            alt="camera"
            height={22}
            width={22}
            className="cursor-pointer"
          ></img>
        </div>
        {isCameraOn && <div
          className="text-white"
          onClick={() => {
            setCamSelectorVisible(true);
          }}
        >
          <AiOutlineUp
            size={16}
            color={"#ffffff"}
            className="cursor-pointer"
          />
        </div>}

        {!isRecord && <div
          className="text-white"
          style={{marginBottom: '8px'}}
          onClick={() => {
            dispatch(setRotateDegree(rotateDegree + 90));
          }}
        >
          <img src={Rotate} alt="select-cam" height={22} width={22} className="cursor-pointer"></img>
        </div>}

        {publicUserData?.live_videos && isHost() ?
         isGoliveStatus  ? (
          <div className="text-white" onClick={toggleRecording}>
            {loading ? (
              <>
                <img
                  src={RecordReady}
                  alt="camera"
                  height={22}
                  width={22}
                  className="cursor-pointer"
                ></img>
              </>
            ) : (
              <>
                <img
                  src={isRecord ? RecordON : RecordOFF}
                  alt="camera"
                  height={22}
                  width={22}
                  className="cursor-pointer"
                ></img>
              </>
            )}
          </div>
        ) : (
          <img
            src={RecordOFF}
            alt="camera"
            height={22}
            width={22}
            className="cursor-pointer"
          ></img>
        ) : <></>}

        {isHost() && <div className="border-l-[0.5px] border-[#DEDEDE]/[0.4] h-[50%]"></div>}
        {isHost() && <div className="text-white">
          <AiFillSetting
            size={22}
            color={"#ffffff"}
            className="cursor-pointer"
            onClick={() => {
              isShowSettings
                ? dispatch(hideSettingPage())
                : dispatch(showSettingPage());
            }}
          ></AiFillSetting>
        </div>}
        {countdown > 0 && (
          <div className="text-white text-2xl">{countdown}</div>
        )}
      </div>
    </>
  );
};

export default StreamControls;
